import {createBrowserRouter,RouterProvider,BrowserRouter,Routes,Route} from 'react-router-dom';
import { Login } from "./Components/Login";
import { useEffect } from "react";
import api from "./API/api";
import { useDispatch } from "react-redux";
import { loadData } from "./state/alldata";
import { PlaformStats } from "./Components/PlaformStats";
import { Layout } from "./Components/Layout";

import { Reset } from "./Components/Reset";
import { PasswordReset } from "./Components/ResetPassword";
import { LoginPasswordReset } from "./Components/LoginReset";
import { Root } from './Components/Root';
import { MyStudio } from './Components/MyStudio';
import { MyModels } from './Components/MyModels';
import { Img3D } from './Components/Img3D';
import { Text3D } from './Components/Text3D';
import { ImgMesh } from './Components/ImgMesh';
import { SketchTo3D } from './Components/SketchTo3D';



function App() {

  const dispatch = useDispatch()

  useEffect(()=>{
      
  },[])
  return <BrowserRouter>
  {/* All routed components will be passed as children to Mainlaout*/}
      <Routes>
          <Route path='/' element={<Root/>}></Route>
          <Route path="/login" element={<Login></Login>}></Route>
          <Route path="/reset" element={<Reset></Reset>}></Route>
          <Route path="/resetPassword" element={<PasswordReset></PasswordReset>}></Route>
          <Route path="/LoginPasswordReset" element={<LoginPasswordReset/>}></Route>
          <Route element={<Layout/>}>
            <Route path="/home" element={<MyStudio/>}></Route>
            <Route path="/MyModels" element={<MyModels/>}></Route>
            <Route path="/Text3D" element={<Text3D/>}></Route>
            <Route path="/Img3D" element={<Img3D/>}></Route>
            <Route path="/SketchTo3D" element={<SketchTo3D/>}></Route>
            <Route path="/ImgMesh" element={<ImgMesh/>}></Route>
          </Route>
        </Routes>
  </BrowserRouter>
  ;
}

export default App;
